module.exports = __webpack_public_path__ + "static/chauffage3-04a098f669c2dcbcc2652718ba38bf5f.jpg";